import { render, staticRenderFns } from "./ExerciciosCompletePergunta.vue?vue&type=template&id=402573a8&"
import script from "./ExerciciosCompletePergunta.vue?vue&type=script&lang=js&"
export * from "./ExerciciosCompletePergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports